import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ShopService } from '@app/services/shops/shop.service';
import { mapToggleFieldToAction } from '../../store/actions';
import { getToggleSelectorFromFieldName } from '../../store/selectors/dashboard';
import { IState } from '../../store/states';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-dashboard-toggle-subsection',
  templateUrl: './dashboard-toggle-subsection.component.html',
  styleUrls: ['./dashboard-toggle-subsection.component.scss', '../../styles/_dashboard.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class DashboardToggleSubsectionComponent implements OnInit, OnDestroy {
  @Input() title: string;
  @Input() fieldName: string;

  private _currentShopId: number;
  private ngUnsubscribe$ = new Subject<any>();

  public isActive: boolean;

  constructor(
    private dashboardStore: Store<IState>,
    private _shopService: ShopService,
  ) {}

  ngOnInit(): void {
    this.initActiveStatus();
    this.initCurrentShop();
  }

  private initCurrentShop(): void {
    this._shopService.shop$
      .pipe(untilDestroyed(this))
      .subscribe((currentShop) => (this._currentShopId = currentShop?.id));
  }

  private initActiveStatus(): void {
    const selector = getToggleSelectorFromFieldName(this.fieldName);
    this.dashboardStore
      .select(selector)
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((isActive) => {
        this.isActive = isActive;
      });
  }

  toggleChange(): void {
    const action = mapToggleFieldToAction(this.fieldName);
    const props = {
      [this.fieldName]: !this.isActive,
      shopId: this._currentShopId,
    };
    this.dashboardStore.dispatch(action(props));
  }

  ngUnsubscribe(): void {
    this.ngUnsubscribe$.next(true);
    this.ngUnsubscribe$.complete();
  }

  ngOnDestroy() {
    this.ngUnsubscribe();
  }
}
